import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
} from '@backstage/core-plugin-api';
import { apiDocsConfigRef } from '@backstage/plugin-api-docs';
import { testJwtDefinitionWidgets } from './components/TestJwt';

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),
  createApiFactory({
    api: apiDocsConfigRef,
    deps: {},
    factory: () => {
      const widgets = testJwtDefinitionWidgets();
      return {
        getApiDefinitionWidget: entity =>
          widgets.find(w => w.type === entity.spec.type),
      };
    },
  }),
];
